import { useContext, useState } from 'react'

import Tabs from '@/components/Tabs'
import DepositPanel from './DepositPanel'
import WithdrawPanel from './WithdrawPanel'
import OrdersPanel from './OrdersPanel'
import { AuthContext } from '../../contexts/AuthContext'
import { collectionToArray } from '../../utils/collectionToArray'

export default function WalletModal() {
  const { userOrders } = useContext(AuthContext)
  const pendingOrders = collectionToArray(userOrders).filter(({ status }) => status == "NEW")

  return (
    <div>
      <Tabs items={[
        {
          key: 'deposit',
          title: 'Deposit',
          panel: <DepositPanel />
        },
        {
          key: 'withdraw',
          title: 'Withdraw',
          panel: <WithdrawPanel />
        },
        {
          key: 'orders',
          title: pendingOrders?.length > 0 ? <div className="flex items-center">Orders <span className="ml-1 h-2 w-2 block rounded-full bg-[#00fe00]"></span></div> : 'Orders',
          panel: <OrdersPanel orders={pendingOrders} />
        },
      ]} />
    </div>
  )
}